import React from "react";

const Hero = () => {
    return (
        <>
            <section className="max-w-lg lg:max-w-3xl mx-auto mt-12 md:mt-28 text-center">
                <article>
                    <h1 className="font-circular text-4xl sm:text-7xl text-slate-900 font-bold leading-normal md:leading-[1.2]">
                        A supporter is worth a thousand followers.
                    </h1>
                    <p className="font-circular md:max-w-2xl md:mx-auto my-6 text-lg md:text-2xl text-gray-600 leading-normal">
                        A Decentralized application of Buy me a Coffee
                    </p>
                </article>
            </section>
        </>
    );
};

export default Hero;